<!--
로그인 컴포넌트
-->
<template>
  <root-content>
    <pb-row fullHeight align="center" justify="center">
      <!-- simple comment -->
      <pb-column flex>
        <div class="school-ad">
          스쿨투게더 광고 관리 사이트에 오신 것을 환영합니다.
        </div>
      </pb-column>

      <!-- login form -->
      <pb-column flex justify="flex-end">
        <div class="login">
          <pb-divider :distance="2.4">
            <h1>로그인</h1>
            <p class="sub-title">
              이 페이지는 스쿨투게더 광고 관리자 전용 페이지 입니다.
            </p>
          </pb-divider>

          <form @submit="onSubmit">
            <pb-divider :distance="1.3">
              <pb-label htmlFor="id">아이디</pb-label>
              <pb-input
                v-model="id"
                id="id"
                type="text"
                placeholder="아이디를 입력해주세요"
              />
            </pb-divider>

            <pb-divider :distance="1.6">
              <pb-label htmlFor="passwd">패스워드</pb-label>
              <pb-input
                v-model="password"
                id="passwd"
                type="password"
                placeholder="패스워드를 입력해주세요"
              />
            </pb-divider>

            <pb-divider>
              <pb-button
                type="submit"
                size="large"
                full
                :disabled="invalidForm"
              >
                로그인 하기
              </pb-button>
            </pb-divider>
          </form>

          <pb-divider :distance="2.6">
            <pb-button
              type="button"
              size="large"
              color="black-reverse"
              full
              @click="moveHomepage"
            >
              스쿨투게더 공식홈페이지로 이동
            </pb-button>
          </pb-divider>

          <div class="clear-both">
            <pb-float float="right">
              <pb-link href="http://schoolmom.co.kr/service.html">
                스쿨투게더에 광고문의를 하고 싶으신가요?
              </pb-link>
            </pb-float>
          </div>
        </div>
      </pb-column>
    </pb-row>
  </root-content>
</template>

<script>
import { mapActions } from "vuex";
import RootContent from "@/common/RootContent";

export default {
  data() {
    return {
      id: "",
      password: "",
      error: null,
    };
  },
  computed: {
    invalidForm() {
      return !this.id || !this.password;
    },
  },
  watch: {
    id() {
      if (this.error !== null) {
        this.error = null;
      }
    },
    password() {
      if (this.error !== null) {
        this.error = null;
      }
    },
  },
  created() {
    if (this.$store.state.token) {
      this.$router.push("/");
    }
  },
  methods: {
    ...mapActions(["LOGIN"]),

    onSubmit(e) {
      e.preventDefault();

      if (!this.id) {
        this.$alert.error("아이디를 확인해주세요.");
        return;
      }

      if (!this.password) {
        this.$alert.error("패스워드를 확인해주세요.");
        return;
      }

      this.LOGIN({ id: this.id, password: this.password })
        .then(() => {
          this.$router.push("/");
        })
        .catch((err) => {
          this.error = err.data;
          this.$alert.error("아이디 및 비밀번호를 확인해주세요.");
        });
    },

    moveHomepage() {
      // window.location.href = "http://schoolmom.co.kr";
      window.open("http://schoolmom.co.kr", "_blank");
    },
  },
  components: {
    RootContent,
  },
};
</script>

<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.school-ad {
  font-size: 4.2rem;
  font-weight: 900;
  width: 410px;
  line-height: 1.5;
  padding: 48px 16px;
  word-break: keep-all;
}

.login {
  width: 440px;
  padding: 48px;

  h1 {
    font-size: 4rem;
  }

  .error-login {
    font-size: 1.4rem;
    text-align: center;
    color: $red;
  }

  .sub-title {
    font-size: 1.3rem;
    margin-top: 4px;
  }
}

@media (max-width: $min_layout) {
  .school-ad {
    display: none;
  }

  .login {
    width: 100%;
    padding: 2.4rem;
  }
}
</style>
